import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class CurrentMetric extends Field {
  static attributesForModel() {
    return ['currentMetric'];
  }

  get title() {
    return 'Current metric';
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: 'fa-regular fa-gauge' }, text: '67%' };
  }

  contentsForRecord(record): FieldContentsData {
    if (record.currentMetric) {
      return {
        icon: { name: 'fa-regular fa-gauge' },
        text: record.currentMetric,
      };
    }

    return {};
  }
}
